/*

  d i s t i b u t o r  c o n f i g s  i n t e r f a c e
  Distributor Configs Interface

  :description:
  A class that can load distributor configurations.

*/

//
//  :code:
import { loadJSONF } from '../js/requests'
import { talk } from '../js/talk'
import { safeAssembleUrl } from '../js/utils'

//
//  :statics:
//  Variables and static declarations.
export const EYEKANDY_DISTRIBUTOR_CONFIGS_INTERFACE = 'EyekandyDistributorConfigsInterface'

//
//  :classes:
export class EyekandyDistributorConfigsInterface {
  constructor(options) {
    if (typeof options === 'undefined') {
      options = {}
    }
    //
    //  :core:
    //  Core settings and values.
    this.name = 'eyekandy-distributor-configs-interface'
    this.version = 'v4.0.0'
    this.group = '[EYEKANDY-DISTRIBUTOR-CONFIGS-INTERFACE]'

    //
    //  :runtime:
    this.environment = options.environment || 'dev'
    this.urls = {
      dev: `https://network-dev.pointandplace.com/config/`,
      prod: `https://network.pointandplace.com/config/`,
    }

    //
    //  :echo:
    //  Write out into the console that the instance was created.
    talk([this.group, `created a new instance @ '${this.version}'`])
  }

  //
  //  :api:
  //  Exposed API functions for callers.
  //  -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -

  async getConfig(distributor, language) {
    //
    //  :step 1:
    //  Assemble our URL.
    const d = distributor ? `${distributor}` : 'anonymous'
    const baseUrl = this.urls[this.environment] + d
    const mapping = {
      distributor: distributor,
      language: language,
    }

    //
    //  :step 2:
    //  Load our config.
    const config = await loadJSONF(safeAssembleUrl(baseUrl, mapping))

    //
    //  All done, return the config to the caller.
    return config
  }
}
